/* eslint-disable no-param-reassign */

const nativeEvents = {
  // Attach handlers to browser events to mount
  // (There are no unmount handlers since the page is destroyed on navigation)
  setup: (ujs) => {
    if ('addEventListener' in window) {
      ujs.handleEvent('DOMContentLoaded', ujs.handleMount);
    }
  },

  teardown: (ujs) => {
    ujs.removeEvent('DOMContentLoaded', ujs.handleMount);
  },
};

const turboEvents = {
  setup: (ujs) => {
    ujs.handleEvent('turbo:load', ujs.handleMount);
    ujs.handleEvent('turbo:before-render', ujs.handleUnmount);
  },

  teardown: (ujs) => {
    ujs.removeEvent('turbo:load', ujs.handleMount);
    ujs.removeEvent('turbo:before-render', ujs.handleUnmount);
  },
};

export default function (ujs) {
  if (ujs.handleEvent) {
    // We're calling this a second time -- remove previous handlers
    turboEvents.teardown(ujs);
    nativeEvents.teardown(ujs);
  }

  if ('addEventListener' in window) {
    ujs.handleEvent = function (eventName, callback) {
      document.addEventListener(eventName, callback);
    };
    ujs.removeEvent = function (eventName, callback) {
      document.removeEventListener(eventName, callback);
    };
  }

  // Detect which kind of events to set up:
  if (typeof Turbo !== 'undefined') {
    turboEvents.setup(ujs);
  } else {
    nativeEvents.setup(ujs);
  }
}
